const initialState = {
  permission_groups: [],
  loading: true,
  loaded: false,
  fetchInFlight: false,
  // The `getCompanyPermissions` requestId currently allowed to update state.
  // Leaving the tab clears it, so a response that arrives afterward is
  // discarded instead of resurrecting a stale `loaded: true`.
  fetchRequestId: null,
  error: null,
  permissionGroups: {
    items: [],
    loading: false,
    loaded: false,
    error: null,
    creating: false,
  },
  permissionGroupDetail: {
    item: null,
    loading: false,
    error: null,
    updatingName: false,
    deleting: false,
    requestedId: null,
  },
  supervisionSystems: {
    enabledById: {},
    loading: false,
    error: null,
    loaded: false,
    updatingIds: [],
    // `{ id, enabled, disableWork }`, where `disableWork` is only used by
    // control listing edition: 'checking' | 'required' | 'none'.
    pendingChange: null,
    canEditById: {},
  },
  // `GET /api3/company/agent_supervision_config`: `lock` is
  // `{ mode, duration_value, duration_unit }` and `rules` has one
  // `{ action, tracked, warning, lock }` per supervised action.
  agentSupervisionConfig: {
    lock: null,
    rules: [],
    loading: false,
    loaded: false,
    error: null,
    savingLock: false,
    // The last saved lock while a change waits on its save: what a failed
    // save rolls back to.
    savedLock: null,
    // The last saved version of each rule edited since, by action: what a
    // failed save rolls back to.
    pendingRules: {},
    // The rules the in-flight save sent.
    savingRules: [],
  },
  // `GET /api3/company/agent_supervision_config/exemptions`. Its four exempt
  // lists are kept as one list of normalized assignees (see `assignees.js`).
  agentSupervisionExemptions: {
    data: {
      assignees: [],
      admins: [],
      exempt_admins_from_warnings: false,
    },
    loading: false,
    loaded: false,
    error: null,
    saving: false,
  },
  // Control listing edition's two assignee lists. `items` holds the
  // normalized assignees (see `assignees.js`).
  portfolioManagers: {
    items: [],
    loading: false,
    loaded: false,
    error: null,
    saving: false,
  },
  usersWithoutSupervision: {
    items: [],
    loading: false,
    loaded: false,
    error: null,
    saving: false,
  },
  supervisionPolicy: {
    value: null,
    loading: false,
    loaded: false,
    error: null,
    saving: false,
  },
  // Every active branch of the company, `{ id, name }` sorted by name — what a
  // portfolio manager's branch scope is picked from.
  companyBranches: {
    items: [],
    loading: false,
    loaded: false,
    error: null,
  },
};

export default initialState;
